const types = ["Scan", "Ticketing", "Horeca", "Horecapunten", "Aantal per vak"];

export default types;
